import { MenuItem } from "./menu.types";

export const menuItems2: MenuItem[] = [
  {
    id: 5,
    label: "RFQs",
    icon: "las la-file-invoice-dollar",
    permissionId: 11,
    subItems: [
      {
        id: 6,
        label: "list_rfqs",
        icon: "las la-minus",
        to: "/rfqs",
        permissionId: 11,
      },
      {
        id: 7,
        label: "make_rfq",
        icon: "las la-minus",
        to: "/new-rfq",
        permissionId: 12,
      },
    ],
  },
];
